import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import '@/styles/index.scss'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

// 接口错误已在 request 拦截器里提示过，这里兜底吞掉，避免未捕获异常中断渲染让整个后台卡死
function isApiError(e) {
  return !!(e && e.isApiError)
}

Vue.config.errorHandler = (err, vm, info) => {
  if (isApiError(err)) return
  console.error('[admin] 未捕获异常', info, err)
}

window.addEventListener('unhandledrejection', e => {
  if (isApiError(e.reason)) e.preventDefault()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
